import { TypeFamily } from 'app/lib/types/server';

export const translation = {
    account: 'Account',
    action: 'Action',
    activate: 'Activate',
    active: 'Active',
    add: 'Add',
    addToProject: 'Add to $t(glossary:project)',
    addToSpace: 'Add to $t(glossary:project)',
    admin: 'Admin',
    all: 'All',
    apply: 'Apply',
    applyAndClose: 'Apply & Close',
    areYouSure: 'Are you sure?',
    as: 'As',
    back: 'Back',
    backTo: 'Back to',
    calculate: 'Calculate',
    cancel: 'Cancel',
    cancelAllQueries: 'Cancel All My Queries',
    canceling: 'Canceling',
    canceled: 'Canceled',
    cancelExecution: 'Cancel Execution',
    category_one: 'Category',
    category_other: 'Categories',
    changeType: 'Change type',
    changeWarehouse: 'Change Warehouse',
    clear: 'Clear',
    clearAll: 'Clear all',
    cloneProject: 'Clone $t(glossary:project)',
    close: 'Close',
    collaborators: 'Collaborators',
    collapse: 'Collapse',
    collapseAllGroups: 'Collapse all Groups',
    collapseGroup: 'Collapse Group',
    collapseNamed: 'Collapse {{name}}',
    collapseSection: 'Collapse Section',
    columns: 'Columns',
    completed: 'Completed at',
    configuration: 'Configuration',
    connect: 'Connect',
    convert: 'Convert',
    convertToModel: 'Convert to Model',
    convertToTransformation: 'Convert to Transformation',
    copyTooltip_json: 'Copy complete JSON value to the clipboard',
    copyTooltip_text: 'Copy complete text value to the clipboard',
    copiedToClipboard: 'Copied to clipboard',
    copyToClipboard: 'Copy to clipboard',
    count: 'Count',
    create: 'Create',
    created: 'Created',
    createdAt: 'Created At',
    createdBy: 'Created By',
    createGroup: 'Create Group',
    crunchingData: "We're executing your query on Snowflake. This can take a moment.",
    data: 'Data',
    database: 'Database',
    datasets: 'Datasets',
    date: 'Date',
    dataBrowser: 'Data Browser',
    deactivate: 'Deactivate',
    deployedTable: 'Deployed Table',
    deployedTable_other: 'Deployed Tables',
    reactivate: 'Reactivate',
    defaultMailSubject: 'Dataset delivery from Datameer: {{- viewName}}',
    delete: 'Delete',
    deleteFromSnowflake: 'Delete from Snowflake',
    deleteProject: 'Delete $t(glossary:project)',
    deploy: 'Deploy to Snowflake',
    deploy_disabledNoView: 'A $t(glossary:transformation) node must be selected before deploying to Snowflake',
    deploy_disabledNotDeployable: 'Selected node is not deployable to Snowflake',
    deploy_disabledSnowflake: 'There is a problem with the Snowflake connection',
    deploy_disableError: 'Please fix any errors in the node before deploying to Snowflake',
    deployment: 'Deployment',
    deployModel: 'Deploy Model',
    deployModel_disabledNoView: 'A $t(glossary:transformation) node must be selected',
    deployModel_disabledError: 'Please fix any errors in the node before creating or updating a $t(common:model)',
    deployModel_hasModel: 'Model for selected node already exists',
    deployModelFrom: 'Deploy Model From <strong>{{name}}</strong>',
    deprecated: 'Deprecated',
    description_optional: 'Description (Optional)',
    details: 'Details',
    disabled: 'Disabled',
    discardDraft: 'Discard Draft',
    disconnect: 'Disconnect Source',
    downloadNow: 'Download Now',
    duration: 'Duration',
    edit: 'Edit',
    editEtc: 'Edit…',
    email: 'Email',
    email_other: 'Emails',
    enable: 'Enable',
    enabled: 'Enabled',
    end: 'End',
    environment: 'Environment',
    error: 'Error',
    error_other: 'Errors',
    execution: 'Execution',
    expand: 'Expand',
    expandAllGroups: 'Expand all Groups',
    expandGroup: 'Expand Group',
    expandNamed: 'Expand {{name}}',
    expandSection: 'Expand Section',
    failed: 'Failed',
    false: 'False',
    from: 'From:',
    google: 'Google',
    goToExploration: 'Go To Exploration',
    history: 'History',
    inactive: 'Inactive',
    info: 'Info',
    initiating: 'Initiating',
    inputs: 'Inputs',
    inspector: 'Inspector',
    inUse: 'In Use',
    job: 'Job',
    job_other: 'Jobs',
    help: 'Help',
    hideDetails: 'Hide Details',
    lastModified: 'Last Modified',
    lastModifiedBy: 'Last Modified By',
    lastRun: 'Last Run',
    lastUpdated: 'Last updated',
    loading: 'Loading',
    logout: 'Logout',
    materializeTable: 'Materialize Table',
    maximize: 'Maximize',
    message: 'Message',
    millions: '{{value}}M',
    model: 'Model',
    model_other: 'Models',
    modified: 'Modified',
    na: 'N/A',
    naDashes: '--',
    name: 'Name',
    new: 'New',
    newProject: 'New $t(glossary:project)…',
    newSql: 'New SQL Editor',
    newSql_disabledSnowflake: 'There is a problem with the Snowflake connection',
    newSql_disabledNodeType: 'SQL Editor not available on the selected node type',
    newTransformation: 'New $t(glossary:transformation)',
    newTransformation_disabledNoView: 'A node must be selected to create a new $t(glossary:transformation)',
    newTransformation_disabledNoTransform: 'Unable to create a new $t(glossary:transformation) on the current node',
    next: 'Next',
    nextMatch: 'Next Match',
    no: 'No',
    noData: 'No Data',
    nodes: 'Nodes',
    none: 'None',
    notAvailable: 'Not Available',
    null: 'Null',
    off: 'off',
    ok: 'OK',
    on: 'on',
    open: 'Open',
    openNotebook: 'Open Notebook',
    output: 'Output',
    outputs: 'Outputs',
    password: 'Password',
    pause: 'Pause',
    path: 'Path',
    paused: 'Paused',
    pending: 'Pending…',
    period: 'Period',
    preview: 'Preview',
    previousMatch: 'Previous Match',
    processing: 'Processing',
    procedure: 'Procedure',
    productName: 'Datameer',
    projectVersion: 'Project Version',
    readOnly: 'Read Only',
    redeploy: 'Re-deploy',
    redeploy_disabledNoView: '$t(common:deploy_disabledNoView)',
    redeploy_disabledNotDeployable: '$t(common:deploy_disabledNotDeployable)',
    redeploy_disabledSnowflake: '$t(common:deploy_disabledSnowflake)',
    redeploy_disabledInSync: 'Deployment is in sync',
    redeploy_disableError: 'Please fix any errors in the node before re-deploying to Snowflake',
    redeployModel: 'Re-deploy Model',
    redeployModelNamed: 'Re-deploy Model <strong>{{name}}</strong>',
    refresh: 'Refresh',
    reload: 'Reload',
    remove: 'Remove',
    removeAllUnusedDataSources: 'Remove all unused Datasources ({{unusedSourcesCount}})',
    removeFromProject: 'Remove from $t(glossary:project)',
    renameColumn: 'Rename column',
    reRunJob: 'Re-run Model Job',
    restore: 'Restore',
    result: 'Result',
    result_one: '{{count}} result',
    result_other: '{{count}} results',
    resume: 'Resume',
    revoke: 'Revoke',
    rowCount: 'Row Count',
    rows: 'Rows',
    run: 'Run',
    running: 'Running',
    runs: 'Runs',
    scan: 'Scan',
    schedule: 'Schedule',
    scheduled: 'Scheduled',
    scheduledAt: 'Scheduled at',
    search: 'Search',
    select: 'Select…',
    selectAll: 'Select all',
    send: 'Send',
    settings: 'Settings',
    severity: 'Severity',
    showAllN: 'Show all ({{count}})',
    showDeploymentHistory: 'Deployment History',
    showDetails: 'Show Details',
    showHistory: 'Execution History',
    showLess: 'Show less',
    showMore: 'Show more…',
    size: 'Size',
    skipped: 'Skipped',
    snowflake: 'Snowflake',
    start: 'Start',
    started: 'Started at',
    status: 'Status',
    submit: 'Submit',
    submitted: 'Submitted at',
    submitting: 'Submitting',
    succeeded: 'Succeeded',
    succeededWithWarnings: 'Succeeded with Warnings',
    syncProject: 'Refresh Used Snowflake Sources',
    tag: 'Tag',
    tag_other: 'Tags',
    tagModel: 'Tag Model',
    tagModel_disabledError: 'Please fix any errors in the node before creating or updating a $t(common:model) Tag',
    tagName: 'Tag Name',
    target: 'Target',
    table: 'Table',
    table_other: 'Tables',
    thousands: '{{value}}K',
    to: 'To:',
    toggleColumnVisibility: 'Toggle column visibility',
    trigger: 'Trigger',
    triggeredBy: 'Triggered by',
    true: 'True',
    types: {
        [TypeFamily.ARRAY]: 'Array',
        [TypeFamily.BOOLEAN]: 'Boolean',
        [TypeFamily.DATE]: 'Date',
        [TypeFamily.DOUBLE]: 'Double',
        [TypeFamily.GEOGRAPHY]: 'Geography',
        [TypeFamily.INTEGER]: 'Integer',
        [TypeFamily.OBJECT]: 'Object',
        [TypeFamily.STRING]: 'String',
        [TypeFamily.TIME]: 'Time',
        [TypeFamily.TIMESTAMP]: 'Timestamp',
        [TypeFamily.UNSUPPORTED]: 'Unsupported',
        [TypeFamily.VARIANT]: 'Variant'
    },
    ungroup: 'Ungroup',
    unknown: 'Unknown',
    unsavedChanges: 'Unsaved changes',
    update: 'Update',
    upload: 'Upload CSV / Excel',
    user_one: 'user',
    user_other: 'users',
    username: 'Username',
    validate: 'Validate',
    validity: 'Validity',
    version: 'Version',
    view: 'View',
    view_other: 'Views',
    viewMoreOptions: 'View More Options',
    warning: 'Warning',
    warning_other: 'Warnings',
    weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday'
    },
    periods: {
        second_one: 'second',
        second_other: 'seconds'
    },
    frequency: {
        hour: 'Hourly',
        day: 'Daily',
        weekday: 'Daily',
        week: 'Weekly',
        month: 'Monthly',
        quarter: 'Quarterly',
        year: 'Yearly'
    },
    yes: 'Yes',
    filterOnSelected: 'Filter on Selected',
    secondaryDimensionLegend: 'Legend - Secondary Dimension',
    renamed: 'Renamed',
    deleteNotPermitted: 'You have no permission to delete the source.',
    addToSpaceNotPermitted: 'You have no permission to add the source to project.'
};
